<template>
    <section class="relative xl:-mt-[16rem] lg:-mt-60 -mt-20" :style="{ backgroundColor }">
        <div class="max-w-[996px] mx-auto px-4">
            <div class="relative mx-auto max-h-[560px] rounded-3xl shadow-2xl h-full w-full" style="position: relative; padding-top: 56.25%">
                <div
                    v-if="showDiscount"
                    class="absolute xl:-top-[10rem] -top-[95px] xl:-right-[8.5rem] z-10 xl:w-[258px] w-full xl:h-[258px] xl:p-0 p-3 rounded-full text-white text-2xl text-center font-semibold leading-[30px] flex items-center justify-center"
                    :style="{ backgroundColor: discountBadgeColor }"
                >
                    <div class="xl:block flex xl:flex-row flex-col w-full">
                        <p class="font-bold xl:text-[64px] text-[44px] xl:leading-[130%] leading-[90%] lg:mr-0 mr-3" v-html="discountPercentage"></p>
                        <p class="xl:text-[34px] text-[20px]" v-html="discountText"></p>
                    </div>
                </div>
                <iframe
                    :src="videoUrl"
                    loading="lazy"
                    allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;"
                    allowfullscreen="true"
                    class="rounded-lg border-0 w-full h-full xl:top-0 top-10 absolute"
                ></iframe>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps({
    backgroundColor: {
        type: String,
        default: 'transparent'
    },
    videoUrl: {
        type: String,
        default: ''
    },
    showDiscount: {
        type: Boolean,
        default: false
    },
    discountText: {
        type: String,
        default: 'Rabatt'
    },
    discountPercentage: {
        type: String,
        default: '20%'
    },
    discountBadgeColor: {
        type: String,
        default: '#1E40AF'
    },
    videoHeight: {
        type: Number,
        default: 500
    },
    videoHeightMobile: {
        type: Number,
        default: 200
    }
});
const windowWidth = ref(window.innerWidth);

const handleResize = () => {
    windowWidth.value = window.innerWidth;
};

onMounted(() => {
    window.addEventListener('resize', handleResize);
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', handleResize);
});

const dynamicHeight = computed(() => {
    return windowWidth.value >= 767 ? props.videoHeight : props.videoHeightMobile;
});
</script>
